import { createRouter, createWebHistory } from 'vue-router'

// import LoginPage from '@/pages/login/LoginPage.vue'
import HomePage from '@/pages/artpulse/HomePage.vue'
import GalleryPage from '@/pages/artpulse/GalleryPage.vue'
import CommissionPage from '@/pages/artpulse/CommissionPage.vue'
import WorkshopsPage from '@/pages/artpulse/WorkshopsPage.vue'
import KidsClassesPage from '@/pages/artpulse/KidsClassesPage.vue'
import ContactPage from '@/pages/artpulse/ContactPage.vue'
import AboutPage from '@/pages/artpulse/AboutPage.vue'
import ExhibitionPage from '@/pages/artpulse/ExhibitionPage.vue'
import TestimonialPage from '@/pages/artpulse/TestimonialPage.vue'

// import BookMeeting from '@/pages/artpulse/BookMeeting.vue'


const routes = [
  // { path: '/login', component: LoginPage, meta : {requiresAuth: false} },
  {
    path: '/', component: HomePage
  },
  { path: '/gallery', component: GalleryPage },
  { path: '/commission', component: CommissionPage },
  { path: '/workshops', component: WorkshopsPage },
  { path: '/contact', component: ContactPage },
  { path: '/about', component: AboutPage },
  { path: '/kids-classes', component: KidsClassesPage },
  { path: '/exhibition', component: ExhibitionPage },
  { path: '/testimonial', component: TestimonialPage },
  // { path: '/book-meeting', component: BookMeeting },
  // { path: '/', component: Home },
  // { path: '/products', component: Products },
  // { path: '/trainers', component: Trainers },
  // { path: '/reviews', component: ReviewList },
  // { path: '/users', component: UserList },
  // { path: '/sales', component: SalesList },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach((to, from, next) => {
//   const auth = useAuthStore()

//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!auth.token) {
//       next({
//         // path: '/login',
//         // query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })


export default router
